export default "__VITE_ASSET__BmdVP$I___"